import partnerLogo from './partner-logo.vue';
import { normal } from '../defaultSpacing';
let configMixin = {
    data: function() {
        return {
            //  title control
            title: '',
            titleSize: 24,
            //  background control
            bgType: '',
            bgColor: '',
            bgImgOpt: {
                src: '',
                mobileSrc: ''
            },
            ...normal
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        useBgSrc() {
            if (!this.isMobileSize) {
                return this.bgImgOpt.src || this.bgImgOpt.mobileSrc;
            } else {
                return this.bgImgOpt.mobileSrc || this.bgImgOpt.src;
            }
        },
        containerStyle({ bgType, bgColor, paddingTop, marginBottom }) {
            let ret = { paddingTop, marginBottom };
            if (bgType === 'color' && bgColor) {
                ret.backgroundColor = bgColor;
            }
            return ret;
        }
    }
};

export const swiperMixin = {
    data: function() {
        return {
            isMobilePlay: true,
            autoplay: true,
            intervalHandle: null,
            allSliderWidth: 0,
            isOverflow: false,
            swiperMargin: {}
        };
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        },
        clonePartner() {
            if (this.canPlay && this.isOverflow) {
                return [...this.partners, ...this.partners];
            } else {
                return [...this.partners];
            }
        },
        swiperMarginNum() {
            return this.swiperMargin[this.isMobileSize ? 'mobile' : 'pc'];
        },
        canPlay() {
            return this.isMobilePlay ? true : !this.isMobileSize;
        }
    },
    watch: {
        partners: {
            deep: true,
            handler: function(newval) {
                if (newval.length) {
                    this.initSwiper && this.initSwiper();
                }
            }
        }
    },
    beforeUnmount() {
        if (this.onBeforeUnmount) {
            this.onBeforeUnmount();
        }
    },
    methods: {
        resizeListener() {
            let fn = () => this.initSwiper(false);
            window.addEventListener('resize', fn, false);
            this.onBeforeUnmount = () => {
                window.removeEventListener('resize', fn);
                this.intervalHandle && clearInterval(this.intervalHandle);
            };
        },
        initSwiper(reset = false) {
            if (this.$refs.swiper) {
                this.$refs.swiper.style.marginLeft = 0;
            }

            this.calcMoveWidth(reset);
            this.linerMoveInit();
        },
        calcMoveWidth(reset = false) {
            //  reset
            if (reset) {
                this.allSliderWidth = 0;
                this.isOverflow = false;
            }

            //  If there is a value and it is detected as an overflow, then return the calculated value to avoid double calculation of the total width
            if (this.allSliderWidth && this.isOverflow) {
                return;
            }

            this.swiperWidth = this.$refs.swiperContainer?.offsetWidth;

            let sliders = this.$refs.swiper?.children?.length
                ? [...this.$refs.swiper.children]
                : [];
            if (sliders.length > this.partners.length) {
                sliders = sliders.slice(0, sliders.length / 2);
            }
            this.allSliderWidth = sliders.reduce(
                (sum, ele) => sum + ele?.offsetWidth + this.swiperMarginNum,
                0
            );
            this.allSliderWidth -= this.swiperMarginNum;
            this.isOverflow = this.allSliderWidth > this.swiperWidth;
        },
        linerMoveInit() {
            this.intervalHandle && clearInterval(this.intervalHandle);
            if (!this.canPlay) {
                return; 
            }

            let i = 0;
            this.intervalHandle = setInterval(() => {
                if (this.autoplay && this.isOverflow) {
                    let step = 2.5;
                    i += step;
                    this.$refs.swiper.style.marginLeft = `-${i}px`;
                    if (i - this.allSliderWidth > this.swiperMarginNum) {
                        i = i - this.allSliderWidth - this.swiperMarginNum;
                    }
                }
            }, 25);
        },
        switchSlider(direction) {
            if (direction === 'next') {
                this.$refs.slider.swiper.slideNext();
            } else {
                this.$refs.slider.swiper.slidePrev();
            }
        },
        playSlider(flag) {
            if (this.canPlay) {
                this.autoplay = flag;
            }
        }
    }
};

export default {
    mixins: [configMixin],
    data: function() {
        return {
            title: '',
            partners: []
        };
    },
    components: {
        partnerLogo
    }
};
